import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
import moment from "moment";
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  isAuthenticated: false,
  user: {},
  isOAuthSuccess: false,
  oAuthUser: {},
  roleId: null
};

const slice = createSlice({
  name: 'authJwt',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // INITIALISE
    getInitialize(state, action) {
      state.isLoading = false;
      state.isAuthenticated = action.payload.isAuthenticated;
      state.user = action.payload.user;
    },

    // LOGIN
    loginSuccess(state, action) {
      state.isAuthenticated = true;
      state.user = action.payload;
    },

    // OAUTH LOGIN SUCCESS (SET 'oAuthUser' STATE VALUE)
    oAuthLoginSuccess(state, action) {
      state.isOAuthSuccess = true;
      state.oAuthUser = action.payload;
      state.roleId = action.payload?.roles[0]?.id
    },

    // REGISTER
    // registerSuccess(state, action) {
    //   state.isAuthenticated = true;
    //   state.user = action.payload.user;
    // },

    // LOGOUT
    logoutSuccess(state) {
      state.isAuthenticated = false;
      state.user = null;
      state.roleId = null;
    }
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }
  return true;
};

export function setSession(accessToken, token_type) {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('token_type', token_type);
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  } else {
    localStorage.removeItem('accessToken');
    axios.defaults.headers.common.Authorization = null;
  }
};

// ----------------------------------------------------------------------
export function getMe() {
  return async (dispatch) => {
    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const auth0Response = await axios.post('/iapi/me ', {}, { headers: { 'Authorization': `Bearer ${accessToken}` }
      });
      dispatch(slice.actions.oAuthLoginSuccess(auth0Response.data));
    } catch (error) {
      throw (error);
    }

  };
}

export function login({ email, password }) {
  return async (dispatch) => {
    try {
      const response = await axios.post('/api/adminlogin ', {
        email: email,
        password
      });
      const { access_token, token_type } = response.data;
      localStorage.setItem('user', JSON.stringify({'email': email}))
      setSession(access_token, token_type);
      dispatch(slice.actions.loginSuccess(`${token_type} ${access_token}`));
      localStorage.setItem("type_token", response.data.token_type);
      let timeStamp = moment();
      localStorage.setItem("lastTimeStamp", timeStamp);
    } catch (error) {
      throw (error);
    }

  };
}

export function logout() {
  return async (dispatch) => {
    try {
      const response = await axios.post('/api/logout', {});
      setSession(null);
      dispatch(slice.actions.logoutSuccess());
    } catch (error) {
      setSession(null);
      dispatch(slice.actions.logoutSuccess());
      throw (error);
    }
  };
}

// ----------------------------------------------------------------------

export function getInitialize() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const accessToken = window.localStorage.getItem('accessToken');
      const user = window.localStorage.getItem('user');

      if (accessToken && isValidToken(accessToken) && user) {
        setSession(accessToken, JSON.parse(user));

        dispatch(
          slice.actions.getInitialize({
            isAuthenticated: true,
            user: JSON.parse(user)
          })
        );
      } else {
        dispatch(
          slice.actions.getInitialize({
            isAuthenticated: false,
            user: null
          })
        );
      }
    } catch (error) {
      console.error(error);
      dispatch(
        slice.actions.getInitialize({
          isAuthenticated: false,
          user: null
        })
      );
    }
  };
}
